export const getCookie = (name: string, cookieString: string = document.cookie) => cookieString.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop() || '';

export const setCookie = (cName: string, cValue: string, expDays: number) => {
  const date = new Date();
  date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${cName}=${cValue}; ${expires}; path=/`;
};
